export const USER = "user";
export const SEMI_MODERATOR = "semi-moderator";
export const MODERATOR = "moderator";
export const SA = "SA";
export const NOA = "NOA";

export const ALIKE_USER = [USER, SEMI_MODERATOR];
export const ALIKE_MODERATOR = [MODERATOR, SA, NOA];